/** Centered two-pill divider marking an experiment checkpoint, e.g. "Day 0 · Experiment Launched". */
export function DayDividerPill({ day, label }: { day: string; label: string }) {
  return (
    <div className="flex items-center justify-center gap-1 py-1">
      <span className="bg-muted text-muted-foreground rounded-full px-2.5 py-0.5 text-[11px] font-medium">
        {day}
      </span>
      <span className="bg-muted/60 text-muted-foreground rounded-full px-2.5 py-0.5 text-[11px] font-medium">
        {label}
      </span>
    </div>
  );
}
